module.exports = __webpack_public_path__ + "img/colour-logo.e0dfe2a9.png";